import Script from "next/script"
import { JobPage } from "components/Templates/JobPage"
import { fetchTranslations } from "utils"
import { useState } from "react"
import { fetchTesterProps } from "utils/jmeterTesting"

export default function Jobs({ query, locale, isTester }) {
  const [atlasRef, setAtlasRef] = useState()
  return (
    <>
      <Script
        defer
        strategy="lazyOnload"
        onLoad={() => {
          setAtlasRef(window.atlas)
        }}
        src="https://atlas.microsoft.com/sdk/javascript/mapcontrol/2/atlas.min.js"
      ></Script>
      {JobPage({
        whichTranslation: "Jobs",
        which: "jobs",
        query,
        locale,
        isTester,
        atlasRef,
      })}
    </>
  )
}

export async function getServerSideProps({ locale, query }) {
  const jobs = await fetchTranslations({ locale, title: "Jobs" })
  const findJobs = await fetchTranslations({ locale, title: "FindJobs" })
  const jobSearch = await fetchTranslations({ locale, title: "JobSearch" })
  const jobListing = await fetchTranslations({ locale, title: "JobListing" })
  const testerProps = await fetchTesterProps()

  return {
    props: {
      query: {
        search: query.search || "",
        location: query.location || "",
        start_date: query.start_date || "",
        radius: query.radius || 100,
        wage: query.wage || "all",
        job_type: query.job_type || "all",
        facets: query.facets || [],
        sort: query.sort || "relevancy",
      },
      locale,
      messages: {
        ...jobs,
        ...findJobs,
        ...jobSearch,
        ...jobListing,
      },
      ...testerProps,
    },
  }
}
